import Vue from 'vue';
import * as types from './mutation-types';

export const all = ({ commit }) => {
    if (localStorage.getItem('cart_products')) {
        commit(types.ALL, JSON.parse(localStorage.getItem('cart_products')));
    }
};

export const addToCart = ({ commit }, product) => {
    commit(types.ADD_TO_CART, product);
};

export const removeFromCart = ({ commit }, index) => {
    commit(types.REMOVE_FROM_CART, index);
};

export const reset = ({ commit }) => {
    localStorage.removeItem('cart_products');
    commit(types.RESET);
};

export  default {
    all,
    addToCart,
    removeFromCart,
    reset
};
